import { render, staticRenderFns } from "./PackTemplate.vue?vue&type=template&id=6bec54be&"
import script from "./PackTemplate.vue?vue&type=script&lang=js&"
export * from "./PackTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PackTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports